import { EditorState, Transaction } from "prosemirror-state";
import { getTopLevelNodes } from "./GetNodes";

function setHeadingFactory(level: number) {
	return function setHeading(state: EditorState, dispatch?: (tx: Transaction) => void) {
		const pp = getTopLevelNodes(state);
		const tr = state.tr;
		let did = false;
		for (const p of pp) {
			if (
				p.node.type === state.schema.nodes.paragraph ||
				(p.node.type === state.schema.nodes.heading && p.node.attrs.level !== level)
			) {
				if (dispatch) {
					tr.setNodeMarkup(p.pos, state.schema.nodes.heading, {
						align: p.node.attrs.align,
						indent: p.node.attrs.indent,
						level,
					});
				} else {
					return true;
				}
				did = true;
			}
		}
		if (!did) {
			for (const p of pp) {
				if (p.node.type === state.schema.nodes.heading) {
					if (dispatch) {
						tr.setNodeMarkup(p.pos, state.schema.nodes.paragraph, {
							align: p.node.attrs.align,
							indent: p.node.attrs.indent,
						});
					} else {
						return true;
					}
					did = true;
				}
			}
		}
		if (dispatch && did) {
			dispatch(tr.scrollIntoView());
		}
		return did;
	};
}

export const setHeading1 = setHeadingFactory(1);
export const setHeading2 = setHeadingFactory(2);
export const setHeading3 = setHeadingFactory(3);

function headingActiveFactory(level: number) {
	return function isActive(state: EditorState) {
		const pp = getTopLevelNodes(state);
		return (
			pp.length > 0 &&
			pp.every(
				p => p.node.type === state.schema.nodes.heading && p.node.attrs.level === level
			)
		);
	};
}

export const headingActive1 = headingActiveFactory(1);
export const headingActive2 = headingActiveFactory(2);
export const headingActive3 = headingActiveFactory(3);
